import { useRequest } from 'ahooks'
import { useEffect } from 'react'

import usePopup from '../../HYBVant/HPopup/hooks/usePopup'

import { deleteHrmHealth, healthsEmployee, saveHealth } from './service'

export default ({
  employeeIds,
  healthCertificate,
  changeAllHealthCertificate,
  changeHealthCertificateStatus,
  changeEditHealthItem,
  onConfirm
}: any) => {
  const { open, modalData, onCancel, onOpen } = usePopup({})
  useEffect(() => {
    if (employeeIds?.length) {
      detailsOk()
    }
  }, [employeeIds])
  const detailsOk = () => {
    runHhealthsEmployee({
      paged: false,
      cur_page: 0,
      page_size: 999,
      employee_id_list: employeeIds
    })
  }
  // 员工健康证
  const { run: runHhealthsEmployee } = useRequest(healthsEmployee, {
    manual: true,
    onSuccess: (result: any) => {
      const { data } = result
      changeAllHealthCertificate(data)
      onCancel()
    },
    onError: ({ message }) => {
      console.log('error', message)
      changeAllHealthCertificate([])
      onCancel()
    }
  })
  // 保存健康证
  const { run: runSaveHealth, loading: saveHealthLoading } = useRequest(saveHealth, {
    manual: true,
    onSuccess: (result: any) => {
      const { code } = result
      if (code === 2000) {
        detailsOk()
      }
    },
    onError: ({ message }) => {
      console.log('error', message)
    }
  })
  // 删除健康证
  const { run: runDeleteHrmHealth, loading: deleteHrmHealthLoading } = useRequest(deleteHrmHealth, {
    manual: true,
    onSuccess: (result: any) => {
      const { code } = result
      if (code === 2000) {
        detailsOk()
      }
    },
    onError: ({ message }) => {
      console.log('error', message)
    }
  })
  const add = () => {
    changeHealthCertificateStatus('Add')
    onOpen({ status: 'Add' })
  }

  const edit = (index: number) => {
    changeEditHealthItem(healthCertificate?.[index])
    changeHealthCertificateStatus('Edit')
    onOpen({ status: 'Edit' })
  }

  useEffect(() => {
    if (onConfirm) onConfirm(healthCertificate)
  }, [healthCertificate])
  return {
    add,
    edit,
    open,
    modalData,
    onCancel,
    onOpen,
    runSaveHealth,
    runDeleteHrmHealth,
    runHhealthsEmployee,
    saveHealthLoading,
    deleteHrmHealthLoading
  }
}
